import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { collegeErrorPageMessage, commonErrorMessage } from 'src/app/constants/error-message-constant';
import { CommonService } from 'src/app/services/common/common.service';
import Swal from 'sweetalert2';
import { SaveStudentConfirmationDialogComponent } from '../save-student-confirmation-dialog/save-student-confirmation-dialog.component';
declare var $: any;
interface colleges {
  id: any;
  value: string;
}
interface collegeBatch {
  id: any;
  value: string;
}
@Component({
  selector: 'app-dropdown-dialog',
  templateUrl: './dropdown-dialog.component.html',
  styleUrls: ['./dropdown-dialog.component.scss']
})
export class DropdownDialogComponent {
  DropdownForm: FormGroup = this.formBuilder.group({});
  collegeList: any = [];
  collegeBatchList: any = [];
  collegeId: number = 0;
  collegeBatchId: number = 0;
  FileUpload!: File;
  submitted: boolean = false;
  showData: boolean = false;
  commonConstant: any = [];
  commonErrorMessage: any = [];
  errorMessage: any = [];
  protected AllCollegelist: colleges[] = this.collegeList;
  protected AllCollegeBatchlist: collegeBatch[] = this.collegeBatchList;
  public FilterCtrl: FormControl = new FormControl();
  public Ctrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredBatchData: ReplaySubject<any> = new ReplaySubject();

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;

  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filterdata() {
    if (!this.AllCollegelist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.AllCollegelist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.AllCollegelist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterBatchdata() {
    if (!this.AllCollegeBatchlist) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBatchData.next(
      this.AllCollegeBatchlist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  @ViewChild('fileUploadModal') fileUploadModal;
  constructor(public modalService: NgbActiveModal,
    private common: CommonService,
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    public commonService: CommonService,
    public ModalService: NgbModal
  ) { this.common.isSystemAlert = true; }

  ngOnInit() {
    this.filteredData.next(this.AllCollegelist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterdata();
      });
    this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBatchdata();
      });
    this.onInitDropdownForm();
    this.getCollegeList();
    this.commonConstant = CommonConstant;
    this.commonErrorMessage = commonErrorMessage;
    this.errorMessage = collegeErrorPageMessage;
  }

  onInitDropdownForm() {
    this.DropdownForm = this.formBuilder.group({
      File: ['', [Validators.required]],
      CollegeId: ['', [Validators.required]],
      CollegeBatchId: ['', [Validators.required]],
    });
  }

  get dropDownFormControl() {
    return this.DropdownForm.controls;
  }

  getCollegeList() {
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForDropDown;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.collegeList.push({ 'id': data.data[i].collegeId, 'value': data.data[i].collegeName })
          }
          this.filterdata();
        }
      },
      error: (err) => {
        console.log('getHandlerList-Error', err);
      }
    });
  }

  onChangeCollege(e: any) {
    this.collegeBatchList = [];
    this.collegeId = e.value;
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeBatchListByCollegeIdAndCompanyId.replace("{id}", this.collegeId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.collegeBatchList.push({ 'id': data.data[i].collegeBatchId, 'value': data.data[i].batchName })
          }
          this.AllCollegeBatchlist = this.collegeBatchList;
          this.filterBatchdata();
        }
      },
      error: (err) => {
        console.log('getGetRoleById-Error', err);
      }
    });
  }

  onChangeBatch(e: any) {
    this.collegeBatchId = e.value;
  }

  onFileChanged(event: any) {
    let file: any;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      var extn = event.target.files[0].name.substr(
        event.target.files[0].name.lastIndexOf('.') + 1
      );
      if (extn != event.target.files[0].name) {
        var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
        switch (ext.toLowerCase()) {
          case 'xls':
          case 'xlsx':
          case 'csv':
            break;
          default:
            (<HTMLInputElement>document.getElementById('File')).value = '';
            this.DropdownForm.reset();
            this.toastr.error("Please select xls,xlsx and csv files")
            return true;
        }
      } else {
        (<HTMLInputElement>document.getElementById('File')).value = '';
        this.DropdownForm.reset();
        return true;
      }
      reader.onload = function (e) {
        file = e.target;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.FileUpload = event.target.files[0];
    } else {
    }
    return null;
  }

  Upload() {
    const modalRef = this.ModalService.open(SaveStudentConfirmationDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.submitted = true;
        if (!this.DropdownForm.valid) {
          return;
        }
        this.spinner.show();
        let form = new FormData();
        form.append('collegeid', this.collegeId.toString());
        form.append('batchid', this.collegeBatchId.toString());
        form.append('excelStudentFile', this.FileUpload);
        const apiUrl = this.apiUrl.apiUrl.student.UploadFile;
        this.commonService.doPost(apiUrl, form).pipe().subscribe({
          next: async (response) => {
            this.modalService.close('save');
            this.spinner.hide();
            if (response.success) {
              Swal.fire({
                icon: 'success',
                text: response.message,
                allowOutsideClick: false,
                buttonsStyling: false,
                customClass: {
                  confirmButton: 'sweet-alert-button'
                }
              }).then(() => {
                this.spinner.hide();
              })
              this.spinner.hide();
              this.submitted = false;
              this.showData = true;
            }
            else {
              Swal.fire({
                icon: 'error',
                text: response.message,
                allowOutsideClick: false,
                buttonsStyling: false,
                customClass: {
                  confirmButton: 'sweet-alert-button'
                }
              })
              this.spinner.hide();
              this.fileUploadModal.nativeElement.click();
            }
          },
          error: (error) => {
            this.spinner.hide();
            this.fileUploadModal.nativeElement.click();
          }
        });
      }
    })
   
  }
}
